import { useEffect, useState } from 'react'
import { useDevcycle } from './useDevcycle'

export const useFlag = (flag: string) => {
  const { devcycleClient: client, isDevcycleInitialized } = useDevcycle()
  const [value, setValue] = useState<boolean | null>(null)

  useEffect(() => {
    if (!isDevcycleInitialized) return

    const variables = client.allVariables()

    if (!variables[flag]) return

    setValue(variables[flag].value as boolean)
  }, [client, flag, isDevcycleInitialized])

  console.log('[DevCycle] Flag:' + flag, value)
  return value
}
